export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_34389.fd712c84.jpg";